/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {
  InstanceUIConfigResponse,
  InstanceUIConfigSchema,
  OrganizationUIConfig,
  OrganizationUIConfigSchema,
  PatchInstanceUIConfigBody,
  PatchOrganizationUIConfigBody,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({providedIn: 'root'})
export class UiConfigService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Gets an existing ui config for the instance
   * @summary Get Instance Ui Config
   */
  getInstanceUIConfig<TData = InstanceUIConfigResponse>(options?: HttpClientBodyOptions): Observable<TData>;
  getInstanceUIConfig<TData = InstanceUIConfigResponse>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getInstanceUIConfig<TData = InstanceUIConfigResponse>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getInstanceUIConfig<TData = InstanceUIConfigResponse>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/ui-config/instance`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/ui-config/instance`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/ui-config/instance`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Partially updates the instance UI configuration using a schema-validated deep merge.
   *
   * Only defined fields may be updated. Invalid structures or unknown fields result in a 400 error.
   *
   * Only the fields included in the request body are modified.
   *
   * Example:
   * {
   *   "banners": {
   *     "homepage_overlay": {
   *       "url": "https://updated.example.com/new.png"
   *     }
   *   }
   * }
   * @summary Patch Instance Ui Config
   */
  patchInstanceUIConfig<TData = unknown | void>(
    patchInstanceUIConfigBody: PatchInstanceUIConfigBody,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  patchInstanceUIConfig<TData = unknown | void>(
    patchInstanceUIConfigBody: PatchInstanceUIConfigBody,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  patchInstanceUIConfig<TData = unknown | void>(
    patchInstanceUIConfigBody: PatchInstanceUIConfigBody,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  patchInstanceUIConfig<TData = unknown | void>(
    patchInstanceUIConfigBody: PatchInstanceUIConfigBody,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(`${this.baseUrl}/api/ui-config/instance`, patchInstanceUIConfigBody, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(`${this.baseUrl}/api/ui-config/instance`, patchInstanceUIConfigBody, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.patch<TData>(`${this.baseUrl}/api/ui-config/instance`, patchInstanceUIConfigBody, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Creates a ui config for the instance
   * @summary Create Instance Ui Config
   */
  createInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  createInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  createInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  createInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/api/ui-config/instance`, instanceUIConfigSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/api/ui-config/instance`, instanceUIConfigSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/api/ui-config/instance`, instanceUIConfigSchema, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Updates an existing ui config for the instance
   * @summary Update Instance Ui Config
   */
  updateInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  updateInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  updateInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  updateInstanceUIConfig<TData = unknown | void>(
    instanceUIConfigSchema: InstanceUIConfigSchema,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/api/ui-config/instance`, instanceUIConfigSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/api/ui-config/instance`, instanceUIConfigSchema, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/api/ui-config/instance`, instanceUIConfigSchema, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets all existing ui config for an organization
   * @summary Get Organization Ui Configs
   */
  getOrganizationUIConfigs<TData = OrganizationUIConfig[]>(options?: HttpClientBodyOptions): Observable<TData>;
  getOrganizationUIConfigs<TData = OrganizationUIConfig[]>(
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getOrganizationUIConfigs<TData = OrganizationUIConfig[]>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getOrganizationUIConfigs<TData = OrganizationUIConfig[]>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/ui-config/organizations`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/ui-config/organizations`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/ui-config/organizations`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets an existing ui config for an organization
   * @summary Get Organization Ui Config
   */
  getOrganizationUIConfig<TData = OrganizationUIConfig>(
    organizationName: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getOrganizationUIConfig<TData = OrganizationUIConfig>(
    organizationName: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getOrganizationUIConfig<TData = OrganizationUIConfig>(
    organizationName: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getOrganizationUIConfig<TData = OrganizationUIConfig>(
    organizationName: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/api/ui-config/organizations/${organizationName}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/api/ui-config/organizations/${organizationName}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/api/ui-config/organizations/${organizationName}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Partially updates an organization's UI configuration using a schema-validated deep merge.
   *
   * Only fields defined in the organization UI config schema may be updated. Any type mismatch, unknown field, or
   * invalid nested shape results in a 400 error.
   *
   * Only the fields included in the request body are modified.
   *
   * Example:
   * {
   *   "record_tile_logo": "https://updated.example.com/logo.png"
   * }
   * @summary Patch Organization Ui Config
   */
  patchOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    patchOrganizationUIConfigBody: PatchOrganizationUIConfigBody,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  patchOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    patchOrganizationUIConfigBody: PatchOrganizationUIConfigBody,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  patchOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    patchOrganizationUIConfigBody: PatchOrganizationUIConfigBody,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  patchOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    patchOrganizationUIConfigBody: PatchOrganizationUIConfigBody,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
        `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
        patchOrganizationUIConfigBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        },
      );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
        `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
        patchOrganizationUIConfigBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        },
      );
    }

    return this.http.patch<TData>(
      `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
      patchOrganizationUIConfigBody,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      },
    );
  }
  /**
   * Creates a ui config for an organization
   * @summary Create Organization Ui Config
   */
  createOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  createOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  createOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  createOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
        `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
        organizationUIConfigSchema,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        },
      );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
        `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
        organizationUIConfigSchema,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        },
      );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
      organizationUIConfigSchema,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      },
    );
  }
  /**
   * Updates an existing ui config for an organization
   * @summary Update Organization Ui Config
   */
  updateOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  updateOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  updateOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  updateOrganizationUIConfig<TData = unknown | void>(
    organizationName: string,
    organizationUIConfigSchema: OrganizationUIConfigSchema,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
        `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
        organizationUIConfigSchema,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        },
      );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
        `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
        organizationUIConfigSchema,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        },
      );
    }

    return this.http.put<TData>(
      `${this.baseUrl}/api/ui-config/organizations/${organizationName}`,
      organizationUIConfigSchema,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      },
    );
  }
}
